<template>
	<div class="indexlogin">

		<!-- <div class="container">
			<div class="row">
				<div class="col-12 col-sm-9 col-md-7 col-lg-5 m-auto ">
					<div class="card ">
						<div class="card-header bg-white">
							<h3 class="text-center mb-0 text-secondary ptname">
								{{$conf.logo}}
							</h3>
						</div>
						<div class="card-body">
							<el-form ref="ruleForm" :rules="rules" :model="form">
								<el-form-item prop="username">
									<el-input v-model="form.username" size="medium" placeholder="请输入用户名">
										<i slot="prefix" class="el-input__icon icon iconfont icon-people_fill"></i>
									</el-input>
								</el-form-item>
								<el-form-item prop="password">
									<el-input v-model="form.password" size="medium" type="password" show-password
										placeholder="请输入密码" @keyup.enter.native="submit">
										<i slot="prefix" class="el-input__icon icon iconfont icon-lock_fill"></i>
									</el-input>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" size="medium" class="w-100" @click="submit"
										:loading="loading">
										{{loading? '登录中...' : '立即登录'}}
									</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
				</div>
			</div>
		</div> -->
		<div class="login_box">
			<div class="top_header">
				{{$conf.logo}}
			</div>
			<div class="mid_body">
				<el-form ref="ruleForm" :rules="rules" :model="form">
					<el-form-item prop="username" class="username">
						<el-input v-model="form.username" style="min-width:300px" placeholder="请输入用户名">
							<i slot="prefix" class="el-input__icon icon iconfont icon-people_fill"></i>
						</el-input>
					</el-form-item>
					<el-form-item prop="password">
						<el-input v-model="form.password" style="min-width:300px" type="password" show-password
							placeholder="请输入密码" @keyup.enter.native="submit">
							<i slot="prefix" class="el-input__icon icon iconfont icon-lock_fill"></i>
						</el-input>
					</el-form-item>

				</el-form>
				<div class="u-f u-ac u-jsb">
					<div>
						<el-checkbox v-model="jzpassword">记住密码</el-checkbox>
					</div>
					<div class="wjmm" @click="gopage('/register/forgetpwd')">忘记密码？</div>
				</div>
				<div class="btns_b u-f u-ac u-jsb">
					<el-button size="medium" class="btn" round @click="submit" :loading="loading">登录</el-button>
					<el-button size="medium" class="btn" round @click="goregister">注册</el-button>
				</div>
				<div class="u-f u-ac">
					<div @click="isagreeswiper" class="icon iconfont "
						:class="isagree?'icon-icradioture':'icon-icradiofalse'"></div><span class="tktext">我已阅读并同意<span
							class="tk" @click="gopage('/tks/service')">《服务条款》</span>及<span class="tk"
							@click="gopage('/tks/Lineysbh')">《隐私说明》</span></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	let ms = []
	import {
		mapGetters
	} from 'vuex'
	export default {
		data() {
			return {
				loading: false,
				form: {
					username: "",
					password: ""
				},
				rules: {
					username: [{
						required: true,
						message: "请输入用户名",
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: "请输入密码",
						trigger: 'blur'
					}]
				},
				jzpassword: false,
				isagree: false
			}
		},
		computed: {
			...mapGetters([
				'adminIndex'
			])
		},
		mounted() {
			if (localStorage.getItem('uAp')) {
				let jz = JSON.parse(localStorage.getItem('uAp'))
				this.form.username = jz.u
				this.form.password = jz.p
				this.jzpassword = jz.j
			}
		},
		methods: {
			submit() {
				this.$refs.ruleForm.validate((e) => {
					if (!e) return;
					if (!this.isagree) return this.$message.error('请先同意《服务条款》及《隐私说明》')
					// 提交表单
					this.loading = true
					this.axios.post('/admin/login', this.form).then(res => {
						if (res.status != 200) {
							this.$message.error(res.data.msg);
							this.loading = false
							return
						}
						if (this.jzpassword) {
							let jz = {
								u: this.form.username,
								p: this.form.password,
								j: this.jzpassword,
							}
							localStorage.setItem('uAp', JSON.stringify(jz))
						} else {
							localStorage.removeItem('uAp')
						}
						// 存储到vuex
						let data = res.data.data
						this.$cookie.set('token',data.token)
						// 存储到本地存储
						this.$store.commit('login', data)

						// 存储权限规则
						if (data.role && data.role.rules) {
							window.sessionStorage.setItem('rules', JSON.stringify(data.role.rules))
						}
						// 生成后台菜单
						this.$store.commit('createNavBar', data.tree)

						// 成功提示
						this.$message({
							showClose: true,
							message: '登录成功'
						});
						if (this.$openws.ws && this.$openws.ws.getState()) {
							this.$openws.ws.close()
							setTimeout(async () => {
								await this.$openws.openws()
								// await this.$openws.connect(1)
							}, 500)
						} else {
							setTimeout(async () => {
								await this.$openws.openws()
								// await this.$openws.connect(1)
							}, 500)
						}
						if (!JSON.parse(localStorage.getItem('allUserList'))) {
							this.getuser()
						}
						this.loading = false
						// 跳转后台首页
						this.$router.push({
							name: this.adminIndex
						})
					}).catch(err => {
						this.loading = false
					})
				})
			},
			async getuser() {
				await axios.post("/admin/User/userList", {
						page: 1,
						limit: 10000
					}, {
						token: true
					})
					.then(async (res) => {
						if (res.data.code == 200) {
							let allUserList = res.data.data.list
							localStorage.setItem('allUserList', JSON.stringify(allUserList))
						}
					})
					.catch(error => {})
			},
			isagreeswiper() {
				this.isagree = !this.isagree
			},
			goregister() {
				this.$router.push('/register/choose')
			},
			gopage(path) {
				this.$router.push(path)
			}
		},
	}
</script>

<style lang="scss" scoped>
	.icon,
	.iconfont {
		font-family: "iconfont" !important;
		font-size: 20px;
		font-style: normal;
		-webkit-font-smoothing: antialiased;
		-webkit-text-stroke-width: 0.2px;
		-moz-osx-font-smoothing: grayscale;
	}

	.indexlogin {
		background-image: url('../../assets/imgs/login_bgimg.jpg');
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;

		.login_box {
			background-color: #fff;
			padding: 40px 7rem 15px;
			border-radius: 8px;

			.top_header {
				text-align: center;
				font-size: 28px;
				font-weight: 600;
				color: #000;
				margin-bottom: 40px;
			}

			.mid_body {
				.username {
					margin-bottom: 35px;
				}

				.btns_b {
					margin-top: 20px;
					margin-bottom: 20px;

					.btn {
						padding: 10px 37px;
						;
						width: 45%;
					}
				}

				.tktext {
					margin-left: 10px;

					.tk {
						color: #099409;
						cursor: pointer;
					}
				}

				.wjmm {
					cursor: pointer;
				}
			}
		}

	}
</style>